// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e6e627e9","551":"b81011c6","842":"4949ab03"}[chunkId] + ".chunk.js";
};